import { render } from "./pendingList.vue?vue&type=template&id=5f98f142&scoped=true"
import script from "./pendingList.vue?vue&type=script&lang=js"
export * from "./pendingList.vue?vue&type=script&lang=js"

import "./pendingList.vue?vue&type=style&index=0&id=5f98f142&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f98f142"]])

export default __exports__